import API from "api/axiosInstance";
import {
  setDetailSetoranHarian,
  setIsLoading,
  setListPencapaian,
  setListSetoran,
  setListSetoranPerCabang,
  setMessage,
  setPengeluaranSetoran,
  setPengeluaranSetoranGlobal,
  setStatus,
} from "./index";

export const fetchListSetoran = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/keuangan/get-setoran");
    dispatch(setIsLoading(false));
    dispatch(setListSetoran(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchChangeStatusSetoran = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/keuangan/update-setoran`, {
      id,
    });
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchDeleteSetoran = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/keuangan/delete-setoran`, {
      id,
    });
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchEditCatatanSetoran = (id, catatan) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/keuangan/update-catatan-setoran`, {
      id,
      catatan,
    });
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchSaveWarkat = (value) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/keuangan/add-warkat`, value);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchListPencapaian = (req) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get(`/keuangan/get-pencapaian-gabung?${req}`);
    dispatch(setIsLoading(false));
    dispatch(setListPencapaian(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchDetailSetoranPerhari =
  (tgl_kas, waktu_setoran) => async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get(
        "/keuangan/get-setoran-harian?tgl_kas=" +
          tgl_kas +
          "&waktu_setoran=" +
          waktu_setoran,
      );
      dispatch(setIsLoading(false));
      dispatch(
        setDetailSetoranHarian({
          ...response.data.data,
          has_save_warkat: response.data.has_save_warkat,
        }),
      );
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchListSetoranPerCabang =
  (tgl_kas, waktu_setoran) => async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get(
        "/keuangan/list-setoran-percabang?tgl_kas=" +
          tgl_kas +
          "&waktu_setoran=" +
          waktu_setoran,
      );
      dispatch(setIsLoading(false));
      dispatch(setListSetoranPerCabang(response.data.data));
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };

export const fetchPengeluaranSetoran = (value) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post(`/keuangan/add-setoran-terima`, value);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchGetPengeluaranSetoran = (value) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const { tgl_kas, id_cab, waktu_setoran } = value;

    const response = await API.get("/keuangan/setoran-terima", {
      params: {
        tgl_kas,
        id_cab,
        waktu_setoran,
      },
    });

    dispatch(setIsLoading(false));
    dispatch(
      setPengeluaranSetoran({
        list_pendapatan: response.data.list_pendapatan,
        list_pengeluaran: response.data.list_pengeluaran,
      }),
    );
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchGetPengeluaranSetoranGlobal =
  (tgl_kas) => async (dispatch) => {
    dispatch(setIsLoading(true));
    try {
      const response = await API.get("/keuangan/setoran-terima-global", {
        params: {
          tgl_kas,
        },
      });

      dispatch(setIsLoading(false));
      dispatch(setPengeluaranSetoranGlobal(response.data.data));
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
    }
  };
